<template>
  <div :class="'active_scenario_'+currentScenario">
  <div class="tile is-ancestor">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="choose_scenario" v-show="loadedScenario === null">
        <label class="label" v-show="activeSelectList.length > 1">
          {{$t('scenarios.scenarioTemplate')}}
        </label>
        <div class="select is-primary" v-show="activeSelectList.length > 1">
          <select v-model="currentScenario" class="form-control" v-bind:disabled="loadedScenario !== null">
            <option value="empty" disabled>{{$t('scenarios.chooseScenarioTemplate')}}</option>
            <option v-for="scenario in activeSelectList" v-bind:value="scenario.name">
              {{scenario.label}}
            </option>
          </select>
        </div>
        </div>

        <scenario-question-recognition v-if="currentScenario === selectList[0].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-question-recognition>
        <scenario-question-yes-no v-if="currentScenario === selectList[1].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-question-yes-no>
        <scenario-two-level-yes-no v-if="currentScenario === selectList[2].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-two-level-yes-no>
        <scenario-notice v-if="currentScenario === selectList[3].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-notice>
        <scenario-question-interview v-if="currentScenario === selectList[4].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-question-interview>
        <scenario-denta-promotion v-if="currentScenario === selectList[5].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-denta-promotion>
        <scenario-akvamir v-if="currentScenario === selectList[6].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-akvamir>
        <AudioCustomizer v-if="otherTemplate(currentScenario)" :campaignid=campaignid :name=id @set="setScenario" :p-scenario.sync="loadedScenario"></AudioCustomizer>
        <Konstruktor v-if="currentScenario === selectList[7].name" :campaignid=campaignid :name=id @set="setScenario" :available-sms-gateways.sync="availableSmsGateways" :p-scenario.sync="loadedScenario"></Konstruktor>
        <scenario-question-yes-no-multi-lang v-if="currentScenario === selectList[8].name" :campaignid=campaignid :name=id @set="setScenario"></scenario-question-yes-no-multi-lang>
      </article>
    </div>
  </div>
  </div>
</template>

<script>
  import ScenarioQuestionRecognition from './depricated/ScenarioQuestionRecognition'
  import ScenarioQuestionYesNo from './depricated/ScenarioQuestionYesNo'
  import ScenarioQuestionYesNoMultiLang from './depricated/1_questionYesNo_i18'
  import ScenarioTwoLevelYesNo from './depricated/ScenarioTwoLevelYesNo'
  import ScenarioQuestionInterview from './depricated/ScenarioQuestionInterview'
  import ScenarioInterviewAFewQuestions from './depricated/ScenarioInterviewAFewQuestions'
  import ScenarioNotice from './depricated/ScenarioNotice'
  import ScenarioDentaPromotion from './depricated/ScenarioDentaPromotion'
  import ScenarioAkvamir from './depricated/ScenarioAkvamir'
  import Konstruktor from './konstruktor/ScenarioKonstruktor'

  import { mapGetters, mapMutations } from 'vuex'
  import Vue from 'vue'
  import CheckToken from '../authentication/CheckToken'
  import AudioCustomizer from './audioCustomizer/AudioCustomizer'
  // import {loadedScenario} from "../../store/getters";

  Vue.mixin(CheckToken)

  const api = '/api/scenarios'
  const APPCONFIG_API = '/api/appConfig'

  export default {
    props: ['campaignid', 'id'],

    computed: {
      ...mapGetters([
        'authenticationToken'
      ])
    },
    methods: {
      ...mapMutations([
        'setLoadedScenario'
      ]),
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadAppConfig () {
        let that = this
        this.$http.get(APPCONFIG_API, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            that.templates = response.data.activeScenarioTemplates
            that.availableSmsGateways = response.data.availableSmsGateways
            for (let i = 0; i < that.selectList.length; i++) {
              if (that.templates[that.selectList[i].name]) {
                that.activeSelectList.push(this.selectList[i])
              }
            }
            that.currentScenario = 'empty'
            that.loadScenario()
          })
          .catch((error) => {
            console.log(error)
            that.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.errorLoadApplicationConfig)
          })
      },
      loadScenario() {
        if (this.$props.id) {
          let that = this
          this.$http.get(`${api}/${this.$props.id}`, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              that.setLoadedScenario(response.data)
              that.loadedScenario = response.data
              that.currentScenario = that.loadedScenario.template
              // return response.data
              console.log('loadedScenario ' + that.loadedScenario)
            })
            .catch((error) => {
              console.log(error)
              that.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.scenario.errorLoadScenario)
            })
        } else {
          this.currentScenario = 'universal'

          this.setLoadedScenario(null)
          return null
        }
      },
      setScenario(value) {
        this.loadedScenario = value
      },

      otherTemplate(currentScenario) {
          if (!currentScenario || (currentScenario === 'empty')) {
              return false
          }
          for (let i = 0; i < this.selectList.length; i++) {
              if (currentScenario === this.selectList[i].name) {
                  return false
              }
          }
          return true
      }
    },
    components: {
      AudioCustomizer,
      Konstruktor,
      ScenarioAkvamir,
      ScenarioQuestionRecognition,
      ScenarioQuestionYesNo,
      ScenarioQuestionYesNoMultiLang,
      ScenarioTwoLevelYesNo,
      ScenarioQuestionInterview,
      ScenarioNotice,
      ScenarioInterviewAFewQuestions,
      ScenarioDentaPromotion
    },
    created: function () {
      this.checkToken()
      // this.currentScenario = this.selectList[0].name
      if (!this.$props.id) {
        console.log('creating new scenario')
        this.appconfig = this.loadAppConfig()
      } else {
        console.log('loading scenario: ' + this.name)
        this.appconfig = this.loadAppConfig()
      }
    },
    data() {
      return {
        currentScenario: '',
        selectList: [
          {
            id: 1,
            name: 'recognition',
            label: 'Вопрос-распознавание'
          },
          {
            id: 2,
            name: 'yesnoonequestion',
            label: '1 вопрос да/нет'
          },
          {
            id: 3,
            name: 'yesnotwoquestions',
            label: '2 уровня вопросов да/нет'
          },
          {
            id: 4,
            name: 'notification',
            label: 'Уведомление'
          },
          {
            id: 5,
            name: 'poll',
            label: 'Опрос'
          },
          {
            id: 6,
            name: 'dentapromotion',
            label: 'Denta promotion'
          },
          {
            id: 7,
            name: 'akvamir',
            label: 'Аквамир'
          },
          {
            id: 8,
            name: 'universal',
            label: 'Конструктор'
          },
          {
            id: 9,
            name: 'yesnoonequestionmultilang',
            label: 'мультиязыч. 1 вопрос да/нет'
          }
        ],
        activeSelectList: [],
        loadedScenario: null,
        templates: {
         name: '',
         active: false
        },
        availableSmsGateways: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Scenario.vue?c4ce311c